<template>
  <div 
    v-if="visible"
    :style="popoverStyle"
    class="email-action-popover"
    @mouseenter="$emit('mouseenter')"
    @mouseleave="$emit('mouseleave')"
  >
    <div class="popover-content">
      <div class="popover-item" @click="$emit('send-email')">
        <b-icon icon="email" size="is-small"></b-icon>
        <span>メールを送付</span>
      </div>
      <div class="popover-item" @click="$emit('email-history')">
        <b-icon icon="email-open" size="is-small"></b-icon>
        <span>メール送受信履歴</span>
      </div>
      <div class="popover-item" @click="$emit('send-sms')" v-if="showSMS">
        <b-icon icon="message" size="is-small"></b-icon>
        <span>SMSを送付</span>
      </div>
      <div class="popover-item" @click="$emit('sms-history')" v-if="showSMS">
        <b-icon icon="message-text" size="is-small"></b-icon>
        <span>SMS送受信履歴</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmailActionPopover',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    popoverStyle: {
      type: Object,
      default: () => ({})
    },
    showSMS: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.email-action-popover {
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  z-index: 2147483648;
}

.popover-content {
  padding: 4px 0;
}

.popover-item {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.popover-item:hover {
  background-color: #f5f5f5;
}

.popover-item .icon {
  margin-right: 8px;
}

.popover-item span {
  font-size: 14px;
  font-weight: 600;
}
</style>


// WEBPACK FOOTER //
// src/components2/Manage/modal/EmailActionPopover.vue